import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {UserMessageLayout} from './UserMessageLayout'
import styles from './UserMessageLoading.module.css'

export const UserMessageLoading = () => (
  <UserMessageLayout avatar={<LoadingSkeleton variant="elliptical" height="24px" width="24px" />}>
    <span className={styles.messageMeta}>
      <LoadingSkeleton variant="rounded" height="sm" width="80px" />
    </span>
    <div className={styles.messageText}>
      <LoadingSkeleton variant="rounded" height="sm" width="random" />
    </div>
  </UserMessageLayout>
)
